import * as React from 'react';

export const Map = () =>
    <div id="myMap" style={{height: 500, width: '100%'}}>
    </div>
